var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"header"},[_c('section',{staticClass:"header__title"},[_c('h1',[_vm._v(_vm._s(_vm.$t("password.reset_password")))]),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":_vm.close}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-close")])],1)],1),_c('Steps')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }